import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledRoot = styled.div(({ theme: { spaces } }) => ({
  paddingBottom: `${spaces.default * 0.5}px`,
}))

const StyledText = styled.p(({ theme }) => ({
  margin: 0,
  fontSize: theme.fontSize * 0.875,
  lineHeight: `${theme.fontSize}px`,
}))

const ProductCustomLabel = ({ children }) => (
  <StyledRoot data-test="ProductCustomLabel">
    <StyledText>
      {children}
    </StyledText>
  </StyledRoot>
)

ProductCustomLabel.propTypes = {
  children: PropTypes.string,
}

ProductCustomLabel.defaultProps = {
  children: '',
}

ProductCustomLabel.displayName = 'ProductCustomLabel'
ProductCustomLabel.whyDidYouRender = true

export default React.memo(ProductCustomLabel)
